<style scoped lang="less">
.echart-main {
  width: 100%;
  height: 400px;
}
</style>
<template>
  <div>
    <div class="page-content">
      <div class="title" v-if="isShowTitle">
        <el-row>
          <el-col :span="4">查询结果</el-col>
          <!-- <el-col :span="20" class="text-right">
            <el-button
              size="small"
              type="primary"
              plain
              v-for="(item, index) in downBtn"
              :key="index"
              @click="downCsv(item.value)"
            >{{ item.name }}</el-button>
          </el-col> -->
        </el-row>
      </div>
      <div class="content" v-loading="pageLoading">
        <div :id="echartId" class="echart-main"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "statisticsEchartsOption",
  props: {
    title: String,
    optionData: Object,
    echartId: {
      type: String,
      required: true,
    },
    // downCsvBtn: Function,
    searchZoom: Function,
    startTime: String,
    endTime: String,
    pageLoading: Boolean,
    isShowTitle: Boolean,
    isZoomFun: Boolean,
    isDot:Boolean,
    formatters:Function
  },
  data() {
    return {
      titleTime: "1小时",
      newEchart: "",
      downBtn: [
        {
          name: "下载每1分钟均值",
          value: "1m",
        },
        {
          name: "下载每5分钟均值",
          value: "5m",
        },
        {
          name: "下载每小时均值",
          value: "1h",
        },
        {
          name: "下载每天均值",
          value: "1d",
        },
      ],
      option: {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log("pa", params);
            let html = `
                <div class="tooltip-box">
                ${params[0].name} <br>
                ${params[0].marker}${params[0].seriesName}: ${params[0].value}
                </div>
            `;
            return html;
          },
        },
        legend: {
            data: ["剂量率","雨量"]
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [],
            axisLable: {
              interval: 3,
            },
          },
        ],
        yAxis: [{
          name: "剂量率Gy/h",
          splitLine: {
            show: false, // X轴 网格线 颜色类型的修改
          },
        },{
          name: "雨量mm",
          splitLine: {
            show: false, // X轴 网格线 颜色类型的修改
          },
        }],
        toolbox: {
          show: true,
          orient: "horizontal",
          feature: {
            // type: "png"，
            saveAsImage: {
              //保存图片
              show: true,
            },
            dataZoom: {
              yAxisIndex: "none",
              endValue: 10000,
              title: {
                zoom: "缩放",
                back: "还原",
              },
            },
            // restore: {},
          },
        },
        dataZoom: [
          {
            type: "inside",
            // throttle: 50,
            endValue: 10000,
            zoomOnMouseWheel: false,
            moveOnMouseMove: false,
            filterMode: "empty",
          },
        ],
        series: [
          {
            name: "剂量率",
            type: "line",
            // smooth: true,
            // showAllSymbol: true,
            symbol: "circle",
            symbolSize: 5,
            data: [],
            lineStyle: {
              color: "#6495ed",
              width: 2,
            },
            itemStyle: {
              color: "#6495ed",
            },
            yAxisIndex:0,
            areaStyle: {
              normal: {
                color: new this.$Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#6495ed",
                  },
                  {
                    offset: 0.5,
                    color: "#6495ed",
                  },
                  {
                    offset: 1,
                    color: "rgba(100,149,237,0)",
                  },
                ]),
              },
            },
          },{
            name: "雨量",
            type: "line",
            // smooth: true,
            // showAllSymbol: true,
            symbol: "circle",
            symbolSize: 5,
            data: [],
            lineStyle: {
              color: "#dbbcf3",
              width: 2,
            },
            itemStyle: {
              color: "#dbbcf3",
            },
            yAxisIndex:1,
            areaStyle: {
              normal: {
                color: new this.$Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#dbbcf3",
                  },
                  {
                    offset: 0.5,
                    color: "#dbbcf3",
                  },
                  {
                    offset: 1,
                    color: "rgba(100,149,237,0)",
                  },
                ]),
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    downCsv(time) {
      this.$emit("downCsvBtn", time);
    },
    newEcharts() {
      // console.log('echartId',echartId)
    //   if(this.optionData.unit){
    //     // this.option.yAxis.name = this.optionData.title + this.optionData.unit; //单位
    //   }
      this.option.xAxis[0].data = this.optionData.dataX;
      this.option.series[0].data = this.optionData.dataY; //y轴数据
    //   this.option.series[0].name = this.optionData.title; //展示数据title
    //   this.option.xAxis[0].axisLable.interval = parseInt(
    //     this.optionData.dataX.length / 30
    //   );
    this.option.series[1].data = this.optionData.dataY1;
      if(this.isDot){
        this.option.series[0].symbol = 'none';
      }
      this.newEchart = this.$Echarts.init(
        document.getElementById(this.echartId)
      );
      if(this.formatters){
        this.option.tooltip.formatter = this.formatters;
      }
      // console.log("9999");
      // this.newEchart.addEventListener('click', function(){
      //       alert("这是第二中点击方式");
      //   })
      this.newEchart.setOption(this.option);
    },
    zoomData() {
      this.newEchart.on("dataZoom", (params) => {
        if(this.isZoomFun){
            let startX = params.batch[0].startValue;
            let endX = params.batch[0].endValue;
            let startTime = this.optionData.dataX[startX];
            let endTime = this.optionData.dataX[endX];

            this.optionData.dataX = [];
            this.optionData.dataY = [];
            // this.pageLoading = true;
            this.newEchart.setOption(this.option);
            if (startTime && endTime) {
              this.$emit("searchZoom", startTime, endTime);
            } else {
              this.$emit("searchZoom", this.startTime, this.endTime);
            }
         }
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.newEcharts();
      this.zoomData();
      this.newEchart.dispatchAction({
        type: "takeGlobalCursor",
        key: "dataZoomSelect",
        dataZoomSelectActive: true, // activate or inactivate
      });
    }, 1000);
    // this.newEchart = this.$Echarts.init(document.getElementById(this.echartId));
  },
  created() {},
  watch: {
    optionData: {
      handler(newName, oldName) {
        console.log("list", newName, oldName);
        this.$nextTick(() => {
          this.newEcharts();
        });
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/statisticsComprehensive.vue